<template lang="pug">
  div
    input(
      type='file',
      @change="setDocument",
      :id="scope",
      ref="eventoClick",
      multiple="false",
      :accept="validExtensions",
      style="display:none"
    )
    el-row.titulo
      .left
        .label {{ titulo }} &nbsp
          span(v-if="required").required * &nbsp
      .right
        el-button.btn(
          type="primary",
          @click="callEventClick()",
        )
          span.center
            i.material-icons.icon attach_file
            b &nbsp Anexar

    .divider
    el-row
      div(:class="{'box-erro' : !isValid || hasError}")
        el-table(
          :data='arquivos',
          stripe
        )
          div(slot='empty')
            span Nenhum arquivo adicionado. Para adicionar um novo arquivo, clique no botão "Anexar" acima.
          el-table-column(
            prop='nome',
            :label='tituloLabel'
          )
          el-table-column(
            label='Ação',
            align="center",
            width="85"
          )
            template(slot-scope='scope')
              app-action-button(
                icone="material-icons",
                nome="clear",
                @click="deleteRow(scope.row)",
                hoverColor="firebrick",
                text="Remover documento"
              )
      p.help.erro(v-show="!isValid") {{ extensionValidateMessage }}
</template>

<script>
import { mapActions } from 'vuex'
import AppActionButton from '@/components/AppActionButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppActionButton
  },

  props: {
    validExtensions: {
      type: Array,
      required: true
    },
    maxSize: {
      type: Number,
      required: true
    },
    scope: {
      type: String,
      required: true
    },
    arquivos: {
      type: Array,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    tituloLabel: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      fileUpload: {},
      isValid: true
    }
  },

  methods: {
    ...mapActions({
      uploadAnexo: 'upload/uploadAnexo'
    }),

    setDocument () {
      const input = document.getElementById(this.scope)
      const file = input.files[0]
      if (file === undefined) {
        return
      }

      this.isValid = this.validateArquivo(file)
      if (!this.isValid) {
        input.value = ''
        return
      }
      input.value = ''
      const blob = file.slice(0, file.size, file.type)
      const newFile = new File([blob], file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), { type: file.type })

      this.fileUpload = newFile

      this.anexarDocumento()
    },

    async anexarDocumento () {
      try {
        const resp = await this.uploadAnexo(this.fileUpload)
        this.$emit('addArquivo', {
          nome: this.fileUpload.name,
          key: resp
        })
        this.fileUpload = {}
        document.getElementById(this.scope).value = ''
      } catch (e) {
        this.showWarning(this.$messages.TITULO_WARNING, this.$messages.ARQUIVO_NOME_INVALIDO)
      }
    },

    callEventClick () {
      this.$refs.eventoClick.click()
    },

    validateArquivo (file) {
      const fileExtension = `.${file.name.split('.').pop()}`.toLowerCase()
      if (!this.validExtensions.find(extension => fileExtension === extension)) {
        this.showWarning(this.$messages.TITULO_WARNING, this.extensionValidateMessage)
        return false
      }
      const isLtMaxSize = file.size / 1024 / 1024 < this.maxSize
      if (!isLtMaxSize) {
        this.showWarning(this.$messages.TITULO_WARNING, this.$messages.ARQUIVO_SIZE_FAIL.replace('$$', this.maxSize))
        return false
      }
      return true
    },

    deleteRow (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING, () => {
        this.$emit('removeArquivo', documento)
      })
    },

    getValidationName () {
      return `${this.scope}.${this.titulo}`
    }
  },

  computed: {
    extensionValidateMessage () {
      return this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.validExtensions.join(', '))
    }
  }

}
</script>

<style scoped lang="scss">
  .btn {
    padding: 7px;
  }

  .divider {
    border: 1px solid #dfe4ed;
    margin-bottom: 20px;
  }

  .titulo {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1vh;
    margin-top: 3vh;
    align-items: flex-end;
    color: #444444;
  }

  .left {
    width: 50%;
    display: flex;
    justify-content: flex-start;
  }

  .right {
    width: 50%;
    display: flex;
    justify-content: flex-end;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .icon {
    font-size: 16px;
  }

  .label {
    font-weight: bold;
    color: #424242;

    .required {
      color: firebrick;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppAnexarArquivo.vue